/**
 * Paths that mount the shared public header and footer
 * (PublicHeader + PublicSiteFooter inside PublicShell).
 *
 * Present: /planos, /contato, /termos, /privacidade, /reembolso,
 * including a path beneath each of those.
 * Absent on purpose: `/` and the five auth routes
 * (/login, /registro, /esqueci-senha, /redefinir-senha, /verificar-email).
 * A longer unrelated path such as /contatos or /planos-extra does not match.
 *
 * Path only. A signed-in free user on `/planos` is not a path exception:
 * `isSignedInFreeOnPlanos` (`freePlanosShell.ts`) is what `PublicLayout`
 * applies on top of this, so `/contato` and the legal pages still match.
 */
const SHARED_PUBLIC_CHROME_PREFIXES = [
  "/planos",
  "/contato",
  "/termos",
  "/privacidade",
  "/reembolso",
] as const;

export function showsSharedPublicChrome(pathname: string): boolean {
  return SHARED_PUBLIC_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
